/// <reference path="../types.d.ts" />
import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { NormalTime } from './action-types';
import { HttpMethods } from '@codametrix/ui-common';
const listNormalTime = createAsyncThunk(NormalTime.LIST_NORMAL_TIME, async (params, { dispatch, getState, rejectWithValue })=>{
    const { dateToday, userId, tenantId } = params;
    const startDate = getDateOfEntry('Sunday', dateToday, dateToday.toLocaleDateString('en-us', {
        weekday: 'long'
    }));
    const endDate = getDateOfEntry('Saturday', dateToday, dateToday.toLocaleDateString('en-us', {
        weekday: 'long'
    }));
    const listParams = `userUid=${userId}&tenantId=${tenantId}&startDate=${startDate}&endDate=${endDate}`;
    let normalTimeWeek = await api({
        endpoint: `/api/coder-activity/work-log/normal/user/tenant/v1?${listParams}`,
        init: {
            method: HttpMethods.GET
        }
    });
    return normalTimeWeek.content;
});
// Getting date of DayOfWeek in current week relative to today's date
const getDateOfEntry = (dayOfWeek, dateToday, dayOfWeekToday)=>{
    const daysOfWeek = Object.freeze([
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]);
    const dayIndex = daysOfWeek.indexOf(dayOfWeek);
    const todayDayIndex = daysOfWeek.indexOf(dayOfWeekToday);
    let targetDay = new Date();
    let compareDate = dayIndex - todayDayIndex;
    if (compareDate < 0) {
        compareDate = Math.abs(compareDate);
        targetDay.setDate(dateToday.getDate() - compareDate % 7);
    } else {
        targetDay.setDate(dateToday.getDate() + compareDate % 7);
    }
    return targetDay.toISOString().split('T')[0];
};
const saveNormalTime = createAsyncThunk(NormalTime.SAVE_NORMAL_TIME, async (value, { dispatch, getState, rejectWithValue })=>{
    const endpoint = `/api/coder-activity/work-log/normal/v1`;
    const hours = value.hours;
    const userId = value.user.userId;
    const fullName = value.user.firstName + ' ' + value.user.lastName;
    const tenantId = value.context.activeContext?.tenantId;
    const workingHoursList = [];
    const dateToday = new Date();
    const dayOfWeekToday = new Date().toLocaleDateString('en-us', {
        weekday: 'long'
    });
    for(const key in hours){
        const hoursWorked = hours[key];
        workingHoursList.push({
            userUid: userId,
            tenantId: tenantId,
            name: fullName,
            dateOfEntry: getDateOfEntry(key, dateToday, dayOfWeekToday),
            day: key,
            hoursWorked: hoursWorked
        });
    }
    const res = await api({
        endpoint: endpoint,
        init: {
            method: HttpMethods.POST
        },
        body: workingHoursList
    });
    return res;
});
export { listNormalTime, saveNormalTime };
